import { ProviderType, RedirectOutputType } from './providerTypes'
import { constructDIDProviderUrl } from '@/utils/didHelpers'

export const nemId: ProviderType = {
  id: 'nemId',
  displayName: 'NemID',
  showLogo: false,
  showSubmit: false,
  redirectOutput: (): RedirectOutputType => {
    return {
      url: constructDIDProviderUrl(
        {
          provider: 'gii-nemid',
          display: 'inline-popup',
          country: 'DK'
        }
      ),
      id: 'nemId',
      container: 'iframe',
      containerHeight: 400,
      autoShow: {
        default: true
      }
    }
  }
}
